<template>
    <section class="content-box box">
        <h2>{{ title }}</h2>
        <div v-if="createdTitle">{{ language.main.adduser.added_desc }}</div>
        <div class="text-danger" v-if="errorlog.length > 0">
            <ul>
                <li v-for="error in errorlog" :key="error">{{ error }}</li>
            </ul>
        </div>
        <form>
            <div class="form-group">
                <input
                    type="text"
                    class="form-control"
                    :placeholder="language.main.name"
                    v-model="form.name"
                />
                <input
                    type="email"
                    class="form-control"
                    :placeholder="language.main.email"
                    v-model="form.email"
                />
                <input
                    type="password"
                    class="form-control"
                    :placeholder="language.main.code"
                    v-model="form.password"
                />
                <input
                    type="password"
                    class="form-control"
                    :placeholder="language.main.code_confirm"
                    v-model="form.password_confirmation"
                />
                <small>{{ language.main.adduser.pass_desc}} </small>
                <input
                    type="button"
                    class="submit"
                    :value="language.main.register"
                    @click="register"
                />
            </div>
        </form>
    </section>
</template>

<script>
export default {
    props: {
        language: Object,
        action: String,
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
            },
            errors: [],
            createdTitle: null,
        }
    },
    computed: {
        errorlog() {
            let output = []

            Object.keys(this.errors).forEach(item => {
                output.push(...this.errors[item])
            })

            return output
        },
        title() {
            return this.createdTitle ? this.createdTitle : this.language.main.register
        }
    },
    methods: {
        register() {
            axios.post('/register', this.form)
                .then(({ data, status }) => {
                    this.reset()
                    console.log(status)
                    if (status === 201) {
                        window.location = '/account'
                    }
                    if (data.redirect) {
                        window.location = data.redirect
                    } else {
                        this.createdTitle = this.language.main.adduser.added
                    }
                })
                .catch(error => {
                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                })
        },
        reset() {
            this.form = {
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
            }
            this.errors = []
        }
    }
}
</script>

<style lang="scss" scoped>
.box {
    width: 360px;
    margin: 0 auto;
}

.submit {
    margin-top: 25px;
    width: 100%;
}

ul {
    padding-left: 20px;
}
</style>
